import React from "react";
import { Typography } from "@mui/material";

export default function MuiTypographySx() {
  return (
    <Typography
      sx={{
        color: "#cccccc",
        fontSize: "20px",
        fontWeight: 700,
        fontFamily: "Roboto",
        textAlign: "center",
        letterSpacing: "2px",
        lineHeight: "2rem",
        textTransform: "uppercase",
        textShadow: "1px 1px 2px black, 0 0 1em blue, 0 0 0.2em",
        width: "fit-content",
        backgroundColor: "#ccc",
        padding: "5px",
      }}
    >
      Text Custom Styling
    </Typography>
  );
}
